import React from 'react';
import { translate } from '@utils/i18n';
import './styles.scss';
const namespace = 'features.ia_teaser_mode_banner';
const PRODUCT_PAGE_URL = 'https://www.inspectpoint.com/inspection-assistant-customer-product';
function IaTeaserModeBanner({ bannerMode }) {
    const handleOpenProductPage = () => {
        // Open from user gesture (click) to avoid popup blocker
        // Use noopener,noreferrer to prevent reverse-tabnabbing attacks
        window.open(PRODUCT_PAGE_URL, '_blank', 'noopener,noreferrer');
    };
    return (React.createElement("div", { className: "ia-teaser-mode-banner" },
        React.createElement("div", { className: "ia-teaser-mode-banner__content" },
            React.createElement("strong", null, translate(`${bannerMode}_title`, { namespace })),
            ' ',
            translate(`${bannerMode}_description`, { namespace })),
        bannerMode === 'inspection' && (React.createElement("button", { className: "ia-teaser-mode-banner__upgrade-now", onClick: handleOpenProductPage, type: "button", "aria-label": translate('upgrade_now_button_title', { namespace }), title: translate('upgrade_now_button_title', { namespace }) },
            React.createElement("i", { className: "fa-sharp fa-light fa-star-shooting" }),
            React.createElement("span", null, translate('upgrade_now_button_title', { namespace }))))));
}
export default IaTeaserModeBanner;
